import logger from '../utils/logger';
/**
 * Hook personnalisé pour gérer les moyens de paiement
 */

import { useState, useEffect } from 'react';
import { authFetch } from '@/utils/api-headers';
import { API_URL } from '@/lib/config';

export interface PaymentMethod {
  id: string;
  brand: string;
  last4: string;
  exp_month: number;
  exp_year: number;
  is_default: boolean;
}

export function usePaymentMethods() {
  const [methods, setMethods] = useState<PaymentMethod[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await authFetch(`${API_URL}/api/billing/payment-methods`);

      if (response.ok) {
        const data = await response.json();
        setMethods(data.paymentMethods || []);
      } else {
        throw new Error('Failed to load payment methods');
      }
    } catch (err: any) {
      logger.error('Error loading payment methods:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return {
    methods,
    loading,
    error,
    reload: load,
  };
}

